import {
  GET_GALLERY_URL,
  GET_MOMENTS_URL
} from 'app/utils/Constants';

import {
  get
} from 'shared/services/ApiService';

export const getGallery = token => {
  return get(GET_GALLERY_URL(token));
}

export const getMoments = (token, page, perPage) => {
  return get(GET_MOMENTS_URL(token, page, perPage));
}
